import { createSystem, defaultConfig } from '@chakra-ui/react'

import { config, mangoTheme } from './baseTheme'

// Create the v3 system
export const system = createSystem(defaultConfig, config)

// Export for backward compatibility (will be removed after full migration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defaultTheme = mangoTheme as any

// Export partner themes from partnerThemes.ts
export * from './partnerThemes'

// Export base theme pieces
export { config, mangoTheme } from './baseTheme'
